// Pure math for the experimental "estimated time-to-read" unread badge
// (Settings -> Advanced -> Experimental features). Kept import-free so the
// unit test needs no backend.

export const WORDS_PER_MINUTE = 200
/** Flat cost for glancing at a media/file/webxdc/... message. */
export const MEDIA_SECONDS = 10
export const CAP_SECONDS = 10 * 60

export type ReadTimeMessage = {
  text: string | null
  viewType: string
  /** Media duration in ms, 0 when unknown. */
  duration: number
}

/** Seconds needed to read/consume the given messages. */
export function unreadSeconds(messages: ReadTimeMessage[]): number {
  let seconds = 0
  for (const msg of messages) {
    if (msg.text) {
      seconds += (msg.text.trim().split(/\s+/).length / WORDS_PER_MINUTE) * 60
    }
    if (msg.viewType === 'Voice' || msg.viewType === 'Audio') {
      seconds += msg.duration > 0 ? msg.duration / 1000 : MEDIA_SECONDS
    } else if (msg.viewType !== 'Text') {
      seconds += MEDIA_SECONDS
    }
  }
  return seconds
}

/**
 * Badge label for the estimate, or null when there is nothing to show.
 * When only `sampled` of `total` unread messages could be fetched, the
 * estimate is scaled up linearly.
 */
export function readTimeLabel(
  seconds: number,
  sampled: number,
  total: number
): string | null {
  if (sampled === 0) return null
  if (sampled < total) seconds = (seconds * total) / sampled
  if (seconds >= CAP_SECONDS) return `${CAP_SECONDS / 60}+ min`
  return `~${Math.max(1, Math.round(seconds / 60))} min`
}
